// todo: Данил, наверно это не надо

window.CART_ADD_SERVICE_URI = `${window.MOCK_SERVER}/cart/add-service`;
if (document.location.pathname === '/cart') {
  document.addEventListener('DOMContentLoaded', () => {
    $('input.cart-add-keys-service-count').on('change', () => {
      setPriceAdditionalKeys();
    });

    $('.card-order-services-block input').on('change', (e) => {
      const input = $(e.currentTarget);
      const productId = input.closest('.order-item').data('cart-product-id');
      const serviceId = input.data('service-id');
      let count = Number(input.val() - (input.data('min-value') ?? 0));

      if (Number.isNaN(count)) {
        count = input.prop('checked') ? 1 : 0;
      }

      const data = {
        productId,
        serviceId,
        count,
      };

      window.promiseQueue.add('change-cart', () => {
        $.ajax({
          method: 'POST',
          url: window.CART_ADD_SERVICE_URI,
          data,
          cache: false,
        })
          .fail(() => {
            document.modalMessageErrorShow();
            setTimeout(() => {
              document.location.reload();
            }, 1000);
          })
          .then(() => {
            document.updateCartSummary();
          });
      });
    });
  });

  const setPriceAdditionalKeys = () => {
    $('input.cart-add-keys-service-count').each((_, elem) => {
      const input = $(elem);
      const itemCard = input.closest('.order-item');
      const inputLabelPrice = itemCard.find('.cart-add-keys-service-price');

      if (inputLabelPrice.length > 0) {
        inputLabelPrice.text(
          (input.val() - input.data('min-value')) * inputLabelPrice.data('price'),
        );
      }
    });
  };

  setPriceAdditionalKeys();
}
